// INSIDO (16-mensagens-de-voz): pure duration formatting for voice messages.
// No DOM / Solid imports so it can be contract-tested from node.

/**
 * Format a duration in milliseconds as `m:ss` (e.g. `0:02`, `4:30`); hours are
 * prepended as `h:mm:ss` if ever needed. Negative / non-finite input is `0:00`.
 * @param ms Duration in milliseconds
 * @param rounding How to turn milliseconds into whole seconds: `round` for
 *   a known total (2.4s → 0:02, 1.6s → 0:02), `floor` for a running clock,
 *   `ceil` for a countdown of the remaining time
 */
export function formatDuration(
  ms: number,
  rounding: "round" | "floor" | "ceil" = "round",
): string {
  if (!Number.isFinite(ms) || ms <= 0) return "0:00";
  const total = Math[rounding](ms / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const ss = s.toString().padStart(2, "0");
  return h > 0 ? `${h}:${m.toString().padStart(2, "0")}:${ss}` : `${m}:${ss}`;
}

/** Maximum length of a voice message (5 minutes) */
export const VOICE_MAX_MS = 5 * 60 * 1000;

/** When the "approaching the limit" warning appears (4:30) */
export const VOICE_WARN_MS = 4 * 60 * 1000 + 30 * 1000;

/** Hold shorter than this (ms) switches to hands-free mode instead of sending */
export const VOICE_TAP_MS = 300;

/** Horizontal drag (px, to the left) that cancels a held recording */
export const VOICE_CANCEL_DRAG_PX = 80;
